<script>
  import "../public/bootstrap.min.css";

  import GlobalStyle  from "./GlobalStyle.svelte";

  import TopBar   from "./TopBar.svelte";
  // import TopBar2   from "./TopBar2.svelte";
  import Top      from "./Top.svelte";
  import AboutMe  from "./AboutMe.svelte";
  import WhatIveDone from "./WhatIveDone.svelte";
  import WhatIDo  from "./WhatIDo.svelte";
  import Contact  from "./Contact.svelte";

  let scrollY;
  let marigold = false;
  let copper   = false;
  let orange   = true;
</script>

<svelte:head>
  {#if marigold}
    <link href="./Marigold.css" rel="stylesheet">
  {:else if copper}
    <link href="./Copper.css" rel="stylesheet">
  {:else if orange}
    <link href="./Orange.css" rel="stylesheet">
  {/if}
</svelte:head>

<svelte:window bind:scrollY/>

<style>
  main {
    text-align: center;
    padding: 0;
    margin: 0 auto;
  }
</style>

<main>
  <TopBar bind:scrollY></TopBar>

  <Top bind:scrollY></Top>

  <AboutMe></AboutMe>

  <WhatIDo></WhatIDo>

  <WhatIveDone></WhatIveDone>

  <Contact></Contact>
</main>
